import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {UploadTextComponent} from "./upload-text/upload-text.component";
import configMC from "../configMC";

export let routes: Routes = [
    {path: '', redirectTo: configMC.pageUrlHome.slice(1), pathMatch: 'full'},
    {
        path: configMC.pageUrlConfirmCancel,
        loadChildren: () => import('./confirm-cancel/confirm-cancel.module').then(m => m.ConfirmCancelPageModule)
    },
    {path: configMC.pageUrlAuthor, loadChildren: () => import('./author/author.module').then(m => m.AuthorPageModule)},
    {
        path: configMC.pageUrlAuthorDetail,
        loadChildren: () => import('./author-detail/author-detail.module').then(m => m.AuthorDetailPageModule)
    },
    {
        path: configMC.pageUrlExerciseParameters,
        loadChildren: () => import('./exercise-parameters/exercise-parameters.module').then(m => m.ExerciseParametersPageModule)
    },
    {path: configMC.pageUrlHome, loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)},
    {
        path: configMC.pageUrlImprint,
        loadChildren: () => import('./imprint/imprint.module').then(m => m.ImprintPageModule)
    },
    {path: configMC.pageUrlInfo, loadChildren: () => import('./info/info.module').then(m => m.InfoPageModule)},
    {path: configMC.pageUrlKwic, loadChildren: () => import('./kwic/kwic.module').then(m => m.KwicPageModule)},
    {
        path: configMC.pageUrlPreview,
        loadChildren: () => import('./preview/preview.module').then(m => m.PreviewPageModule)
    },
    {
        path: configMC.pageUrlRanking,
        loadChildren: () => import('./ranking/ranking.module').then(m => m.RankingPageModule)
    },
    {
        path: configMC.pageUrlShowText,
        loadChildren: () => import('./show-text/show-text.module').then(m => m.ShowTextPageModule)
    },
    {
        path: configMC.pageUrlSources,
        loadChildren: () => import('./sources/sources.module').then(m => m.SourcesPageModule)
    },
    {path: configMC.pageUrlTest, loadChildren: () => import('./test/test.module').then(m => m.TestPageModule)},
    {
        path: configMC.pageUrlTextRange,
        loadChildren: () => import('./text-range/text-range.module').then(m => m.TextRangePageModule)
    },
    {
        path: configMC.pageUrlVocabularyCheck,
        loadChildren: () => import('./vocabulary-check/vocabulary-check.module').then(m => m.VocabularyCheckPageModule)
    },
    {
        path: configMC.pageUrlExercise,
        loadChildren: () => import('./exercise/exercise.module').then(m => m.ExercisePageModule)
    },
    {
        path: configMC.pageUrlExerciseList,
        loadChildren: () => import('./exercise-list/exercise-list.module').then(m => m.ExerciseListPageModule)
    },
    {
        path: configMC.pageUrlDocVocUnit,
        loadChildren: () => import('./doc-voc-unit/doc-voc-unit.module').then(m => m.DocVocUnitPageModule)
    },
    {
        path: configMC.pageUrlDocExercises,
        loadChildren: () => import('./doc-exercises/doc-exercises.module').then(m => m.DocExercisesPageModule)
    },
    {
        path: configMC.pageUrlDocSoftware,
        loadChildren: () => import('./doc-software/doc-software.module').then(m => m.DocSoftwarePageModule)
    },
    {
        path: configMC.pageUrlSemantics,
        loadChildren: () => import('./semantics/semantics.module').then(m => m.SemanticsPageModule)
    },
    {
        path: configMC.pageUrlEmbed,
        loadChildren: () => import('./embed/embed.module').then(m => m.EmbedPageModule)
    },
    {
        path: configMC.pageUrlSequences,
        loadChildren: () => import('./sequences/sequences.module').then(m => m.SequencesPageModule)
    },
    {
        path: configMC.pageUrlTutorial,
        loadChildren: () => import('./tutorial/tutorial.module').then(m => m.TutorialPageModule)
    },
    {path: configMC.pageUrlUploadText, component: UploadTextComponent}

];
// remove slashes from the paths
routes = routes.map((x) => {
    x.path = x.path.slice(1);
    return x;
});

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
